<script setup>
import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import NotificationsBell from '@/components/layouts/NotificationsBell.vue'
import { usePageHeader } from '@/composables/usePageHeader'

const route = useRoute()
const { titleOverride, crumbsOverride, resetPageHeader } = usePageHeader()

watch(() => route.path, resetPageHeader)

const title = computed(() => titleOverride.value || route.meta.pageTitle || '')
const crumbs = computed(() => crumbsOverride.value || route.meta.crumbs || [])
</script>

<template>
  <header class="topbar">
    <div class="topbar__inner">
      <div class="topbar__title">
        <div v-if="crumbs.length" class="crumb">
          <template v-for="(c, i) in crumbs" :key="i">
            <span v-if="i > 0" class="mdi mdi-chevron-right"></span>
            <span>{{ c }}</span>
          </template>
        </div>
        <h1>{{ title }}</h1>
      </div>
      <div class="topbar__actions">
        <!-- pages teleport their action buttons here -->
        <div id="topbar-actions" class="page-actions"></div>
        <NotificationsBell />
      </div>
    </div>
  </header>
</template>
